module.exports = __webpack_public_path__ + "static/media/sports.d90dd146.jpg";